module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-5.a1cdce08.svg";